module.exports = __webpack_public_path__ + "static/media/collaborate.d629dc4f.png";